import React from 'react';
import About from '../components/pages/About';

const AboutPage = (props) => {
    
    return <About />;
};

export default AboutPage;